export function sendAppierConversion(action_id) {
  window.appier_q = window.appier_q || [];
  window.appier_q.push({
    t: 'type_conversion',
    content: 'submit',
    action_id,
    track_id: '77eb0a7748bc95a',
    opts: { unique_key: 'true' },
  });
}
